(function(){
  document.querySelectorAll('[data-stro-home]').forEach(function(root){
  var data = JSON.parse(root.querySelector('[data-stro-data]').textContent);
  data.xl.sort(function(a,b){ return (a.rank||0)-(b.rank||0); });
  var base = (data.root || '/').replace(/\/$/, '');
  var toast = root.querySelector('[data-stro-toast]'), tt;

  function setCount(n){ document.querySelectorAll('[data-stro-count]').forEach(function(el){ el.textContent = n; }); }
  function showToast(name, err){
    toast.querySelector('b').textContent = err ? 'Heads up' : 'Added to bag';
    toast.querySelector('[data-toast-name]').textContent = name;
    toast.classList.add('is-on'); clearTimeout(tt);
    tt = setTimeout(function(){ toast.classList.remove('is-on'); }, 2600);
  }
  function add(id, name, btn){
    if (!id) return;
    if (btn) btn.disabled = true;
    fetch(base + '/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[{ id: Number(id), quantity: 1 }] }) })
      .then(function(r){ if(!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); })
      .then(function(){ return fetch(base + '/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){ setCount(cart.item_count); showToast(name); document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function(e){ showToast((e && e.description) || 'Sorry, that finish is unavailable right now.', true); })
      .finally(function(){ if (btn) btn.disabled = false; });
  }
  root.addEventListener('click', function(e){
    var b = e.target.closest('[data-stro-add]');
    if (b) add(b.getAttribute('data-stro-add'), b.getAttribute('data-stro-name'), b);
  });

  root.querySelectorAll('[data-stro-line]').forEach(function(card){
    var key = card.getAttribute('data-stro-line'), list = data[key] || [], sel = 0;
    var title = key === 'xl' ? data.xlTitle : data.classicTitle;
    var wrap = card.querySelector('[data-swatches]');
    function render(){
      var v = list[sel]; if (!v) return;
      card.querySelector('[data-price]').textContent = v.price;
      card.querySelector('[data-was]').textContent = v.was || '';
      card.querySelector('[data-label]').textContent = v.label;
      wrap.querySelectorAll('button').forEach(function(b,i){ b.setAttribute('aria-pressed', i === sel ? 'true' : 'false'); });
    }
    list.forEach(function(v,i){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'stro-sw__btn sw-' + v.sw; b.title = v.label; b.setAttribute('aria-label', v.label);
      b.addEventListener('click', function(){ sel = i; render(); });
      wrap.appendChild(b);
    });
    var addBtn = card.querySelector('[data-add-line]');
    addBtn.addEventListener('click', function(){ var v = list[sel]; if (v) add(v.id, title + ' \u2014 ' + v.label, addBtn); });
    render();
  });

  var cw = root.querySelector('[data-stro-colours]');
  if (cw && data.classic.length){
    var cur = { xl:false, i:0 };
    var chips = cw.querySelector('[data-c-chips]');
    var img = cw.querySelector('[data-c-img]');
    var pick = function(){ return cur.xl ? data.xl[0] : data.classic[cur.i]; };
    var paint = function(){
      var v = pick(); if (!v) return;
      var prod = cur.xl ? data.xlTitle : data.classicTitle;
      img.src = v.img; img.alt = prod + ' \u2014 ' + v.label;
      cw.querySelector('[data-c-tag]').textContent = cur.xl ? 'XL \u00b7 ' + v.label : v.label;
      cw.querySelector('[data-c-price]').textContent = v.price;
      cw.querySelector('[data-c-name]').textContent = prod + ' \u00b7 ' + v.label.toLowerCase();
      chips.querySelectorAll('button').forEach(function(b,i){ b.setAttribute('aria-pressed', !cur.xl && i === cur.i ? 'true' : 'false'); });
      cw.querySelector('[data-c-xl]').setAttribute('aria-pressed', cur.xl ? 'true' : 'false');
    };
    data.classic.forEach(function(v,i){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'stro-chip';
      var dot = document.createElement('i'); dot.className = 'sw-' + v.sw; b.appendChild(dot);
      b.appendChild(document.createTextNode(v.label));
      b.addEventListener('click', function(){ cur = { xl:false, i:i }; paint(); });
      chips.appendChild(b);
    });
    var xlBtn = cw.querySelector('[data-c-xl]');
    if (!data.xl.length) xlBtn.style.display = 'none';
    xlBtn.addEventListener('click', function(){ cur = { xl:true, i:0 }; paint(); });
    var cAdd = cw.querySelector('[data-c-add]');
    cAdd.addEventListener('click', function(){ var v = pick(); if (v) add(v.id, (cur.xl ? data.xlTitle : data.classicTitle) + ' \u2014 ' + v.label, cAdd); });
    paint();
  }

  var track = root.querySelector('[data-rev-track]');
  root.querySelectorAll('[data-rev]').forEach(function(b){
    b.addEventListener('click', function(){ track.scrollBy({ left: Number(b.getAttribute('data-rev')) * track.clientWidth * 0.8, behavior:'smooth' }); });
  });

  var sticky = root.querySelector('[data-stro-sticky]');
  if (sticky){
    var on = false;
    window.addEventListener('scroll', function(){ var s = window.scrollY > 700; if (s !== on){ on = s; sticky.classList.toggle('is-on', s); } }, { passive:true });
  }

  var vid = root.querySelector('.stro-video video');
  if (vid){ vid.muted = true; var p = vid.play(); if (p && p.catch) p.catch(function(){}); }
  });
})();
